import React, { useEffect, useState } from "react";
import Sidebar from "../../../partials/aside/Sidebar";
import TitleBar from "../../../partials/content/TitleBar";
import helperSpinner from "../../../../helpers/spinner";
import httpService from "../../../../services/httpServices/httpServices";
import helpersTime from "../../../../helpers/time";
import helpersNumber from "../../../../helpers/numbers";
import ExportJsonExcel from "js-export-excel";

export default function ListUserReport() {
  const [roles, setRoles] = useState([]);

  useEffect(() => {
    getRoles();
  }, []);

  const getRoles = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let roles = await sendRequestGetRoles();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!roles) {
      return;
    }
    setRoles(roles);
  };

  const sendRequestGetRoles = async () => {
    const headersRequest = getHeaderForRequest();
    let roles;
    try {
      roles = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/role",
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return roles.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const generateRolesRadioButton = () => {
    return roles.map((role) => {
      return (
        <div className="col-12 col-sm-2 col-md-2">
          <span className=" justify-content-between d-inline-flex align-items-center py-2 ">
            <span>
              <input
                className="hover"
                type="radio"
                name="role"
                value={role.rol_id}
              />
            </span>
            <span className="pr-2 small font-weight-bold text-nowrap ">
              {role.rol_persian_name}
            </span>
          </span>
        </div>
      );
    });
  };

  const sendForm = async () => {
    const roleID = document.querySelector('input[name="role"]:checked').value;
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let users = await sendRequestGetUserList(roleID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!users) {
      return;
    }
    generateExcelFile(users);
  };

  const generateExcelFile = (users) => {
    var option = {};

    option.fileName = "لیست کاربران";

    let sheetData = [
      {
        one: "ردیف",
        two: "نام",
        three: "نام خانوادگی",
        four: "شماره موبایل",
        five: "ایمیل",
      },
    ];

    let counter = 1;
    for (let key in users) {
      const user = users[key];
      sheetData.push({
        one: counter,
        two: user.firstname,
        three: user.lastname,
        four: user.mobile,
        five: user.email,
      });
      counter++;
    }

    option.datas = [
      {
        sheetData: sheetData,
        columnWidths: [5, 5, 5, 10, 10],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  };

  const sendRequestGetUserList = async (roleID) => {
    const headersRequest = getHeaderForRequest();
    let users;
    try {
      users = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/user/list-users-report/role/" +
          roleID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return users.data.data;
  };

  const generateRoles = () => {
    return (
      <form
        onSubmit={(e) => {
          e.preventDefault();
          sendForm();
        }}
      >
        <div className="alert alert-secondary p-2">
          <div className="form-group">
            <div className="container-fluid">
              <div className="row">{generateRolesRadioButton()}</div>
            </div>
          </div>
        </div>
        <button className="btn btn-success">دریافت فایل excel</button>
      </form>
    );
  };

  return (
    <>
      <Sidebar openItem="users" activeItem="list-users" />

      <div className="content-wrapper">
        <TitleBar title="دریافت لیست کاربران" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">{roles && generateRoles()}</div>
          </div>
        </section>
      </div>
    </>
  );
}
